export const DRIVER_SAFETY_SUMMARY_GRAPH_TITLE = "Lowest Rated Drivers";
export const GET_TELEMATICS = "Enquire about Telematics";
export const TELEMATICS_TEXT =
	"Green columns indicate driver behaviour data gathered from Telematics";
export const TELEMATICS_NOT_AVAILABLE =
	"Want more detailed and accurate driver behaviour data for your fleet?";



// WEBPACK FOOTER //
// ./src/features/insights/components/driverSafety/content.js